import React, { useState } from 'react';
import useSWR from 'swr';

import LoadingSpin from '@/components/UI/LoadingSpin';
import MainButton from '@/components/UI/mobile/MainButton';

import AddAndEditTodoModal from './components/AddAndEditTodoModal';
import DeleteModal from './components/DeleteModal';
import TodoList from './components/TodoList';
import { fetchTodoList } from './helpers';
import styles from './index.module.scss';
import type { TodoItem } from './types';

const Reminder = () => {
  const [openEditTodoModal, setOpenEditTodoModal] = useState(false);
  const [editingTodo, setEditingTodo] = useState<TodoItem | undefined>(
    undefined
  );
  const [deleteTodoId, setDeleteTodoId] = useState<string | undefined>(
    undefined
  );

  const {
    data: todoList,
    isLoading: isTodoListFetcherLoading,
    mutate,
  } = useSWR('/ezcon/api/todoList', fetchTodoList);

  if (isTodoListFetcherLoading) {
    return <LoadingSpin />;
  }

  const closeEditTodoModal = () => {
    setEditingTodo(undefined);
    setOpenEditTodoModal(false);
    mutate();
  };

  const handleEditTodoButtonClick = (todoItem: TodoItem) => {
    setEditingTodo(todoItem);
    setOpenEditTodoModal(true);
  };

  const closeDeleteConfirmModal = () => {
    setDeleteTodoId(undefined);
    mutate();
  };

  const isDeleteModalOpen = deleteTodoId !== undefined;

  return openEditTodoModal ? (
    <AddAndEditTodoModal
      closeModal={closeEditTodoModal}
      editingTodo={editingTodo}
    />
  ) : (
    <>
      <div
        className={
          isDeleteModalOpen
            ? `${styles.container} ${styles.userPointerAndTouchActionDisabled}`
            : styles.container
        }
      >
        <MainButton
          onClick={() => {
            setOpenEditTodoModal(true);
          }}
        >
          新增排程
        </MainButton>
        <TodoList
          list={todoList ?? []}
          handleEditTodoButtonClick={handleEditTodoButtonClick}
          openDeleteConfirmModal={(id) => setDeleteTodoId(id)}
        />
      </div>
      {isDeleteModalOpen ? (
        <DeleteModal
          todoId={deleteTodoId}
          closeDeleteConfirmModal={closeDeleteConfirmModal}
        />
      ) : null}
    </>
  );
};

export default Reminder;
